import * as ng from 'angular';
import { StTable } from './st-table.directive';
import { StTableController } from './st-table';

export const StTableModule: string =
    ng.module('st-table', [
    ])
        .controller('stTableController', StTableController)
        .directive('stTable', StTable)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/smart-table/st-table/st-table.module.ts